
import { UnitGrams } from '@/entity/entity'
import IngredientForm from '@/component/IngredientForm.vue'
import Vue from 'vue'

export default Vue.extend({
  name: 'EditIngredient',
  props: {
    id: {
      type: String,
      required: true
    },
    name: String,
    defaultGrams: {
      type: Number,
      default: 0
    },
    defaultOrigin: {
      type: String,
      default: '不明'
    },
    unitGrams: {
      type: Object as () => UnitGrams,
      required: true
    }
  },
  components: {
    IngredientForm
  },
  data: function () {
    return {
      grams: this.defaultGrams,
      origin: this.defaultOrigin
    }
  },
  methods: {
    ingredientFormUpdated: function (e : {grams: number, origin: string}) {
      this.grams = e.grams
      this.origin = e.origin
    },
    emitSave: function () {
      this.$emit('save', {
        grams: this.grams,
        origin: this.origin
      })
    },
    emitClose: function () {
      this.$emit('close')
    }
  }
})
